module.exports = __webpack_public_path__ + "img/payments.9d1ad4bf.svg";